<template>
	<router-link class="cursor-pointer" :to="{ name: routeName, params: { [propIdentifier]: identifier } }">
		<slot>
			<span class="text-info">{{ identifier }}</span>
		</slot>
	</router-link>
</template>

<script>
	export default {
		name: 'AppDetailsShortcut',
		props: {
			routeName: {
				required: true,
				type: [String, Object, Function],
			},
			identifier: {
				required: true,
				type: [String, Number],
			},
			propIdentifier: {
				required: false,
				type: String,
				default: 'id',
			},
		},
	};
</script>
